var resizeTimer;jQuery(document).ready((function(){jQuery("div.category-toggle").click((function(){var t=jQuery(this),e=jQuery(this).next("ul.subcat-list");t.toggleClass("active"),e.toggleClass("active");var i=t.hasClass("active");t.attr("aria-expanded",i),jQuery("ul.subcat-list").not(e).removeClass("active"),jQuery("div.category-toggle").not(t).removeClass("active").attr("aria-expanded",!1)}));var t=window.location.pathname;0==t.indexOf("/collections/")&&-1==t.indexOf("/products/")&&jQuery((function(){$.scrollUp({scrollText:""})}))})),window._minimizeContent=function(){function _minAppend(el,html){var t=el.lastElementChild,host=t&&/^(P|DIV|LI|UL|OL|H[1-6])$/.test(t.tagName)?t:el;if("UL"===host.tagName||"OL"===host.tagName)host=host.lastElementChild||el;var s=document.createElement("span");s.innerHTML=html,host.appendChild(s)}function _minCut(el,n,suffix){el.innerHTML=el._minFull;var nd,w=document.createTreeWalker(el,NodeFilter.SHOW_TEXT),c=0,cutN=null,off=0;for(;nd=w.nextNode();){if(c+nd.data.length>=n){cutN=nd,off=n-c;break}c+=nd.data.length}if(!cutN)return!1;var r=document.createRange();r.setStart(cutN,off),r.setEndAfter(el.lastChild),r.deleteContents();for(var host=cutN.parentNode;host!==el&&!/^(P|DIV|LI|H[1-6])$/.test(host.tagName);)host=host.parentNode;var s=document.createElement("span");return s.innerHTML=suffix,host.appendChild(s),!0}function _minCollapse(el){el.innerHTML=el._minFull,el.classList.add("is-collapsed");var target=el.clientHeight;if(!(el.scrollHeight>target+2))return;var nd,total=0,w=document.createTreeWalker(el,NodeFilter.SHOW_TEXT);for(;nd=w.nextNode();)total+=nd.data.length;for(var suffix='<span class="minimize-ellipsis">... </span><a href="#" class="minimize-more" role="button"><strong>more</strong></a>',lo=0,hi=total,best=0;lo<=hi;){var mid=lo+hi>>1;_minCut(el,mid,suffix),el.scrollHeight<=target+2?(best=mid,lo=mid+1):hi=mid-1}_minCut(el,best,suffix)}document.querySelectorAll(".minimize-rich").forEach((function(el){void 0===el._minFull&&(el._minFull=el.innerHTML),el._minBound||(el.addEventListener("click",(function(ev){var a=ev.target.closest("a.minimize-more,a.minimize-less");a&&el.contains(a)&&(ev.preventDefault(),a.classList.contains("minimize-more")?(el._minExpanded=!0,el.classList.remove("is-collapsed"),el.innerHTML=el._minFull,_minAppend(el,' <a href="#" class="minimize-less" role="button"><strong>less</strong></a>')):(el._minExpanded=!1,_minCollapse(el)))})),el._minBound=!0),el._minExpanded||_minCollapse(el)}))},jQuery(document).ready(window._minimizeContent),window.addEventListener("resize",(function(t){clearTimeout(resizeTimer),resizeTimer=setTimeout((function(){window._minimizeContent()}),250)}),!0),jQuery(document).ready((function(){if(window.location.href.indexOf("glossary")>-1&&$(".alpha-filter").length){var t=["a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z"],e=!1;t.forEach((function(t){$(`.definition-${t}`).length||($(`#alpha-filter-${t}`).hide(),e=!0)})),e&&$("#glossary-filter-wrapper").show(),$(".alpha-filter").click((function(){var e=$(this).attr("id").split("alpha-filter-")[1];e&&($(".alpha-filter").removeClass("alpha-selected"),$(`#alpha-filter-${e}`).addClass("alpha-selected"),t.forEach((function(t){"all"==e||e==t?$(`.definition-${t}`).show():$(`.definition-${t}`).hide()})))}))}})),jQuery(document).ready((function(){$(".product-quantity-input-minus").on("click",(function(t){t.preventDefault();var e=$(".product-quantity-input").val();e||($(".product-quantity-input").val(1),e=1);var i=parseInt(e)-1;i>0&&$(".product-quantity-input").val(i)})),$(".product-quantity-input-plus").on("click",(function(t){t.preventDefault();var e=$(".product-quantity-input").val();e||($(".product-quantity-input").val(1),e=0);var i=parseInt(e)+1;$(".product-quantity-input").val(i)}))})),jQuery(document).ready((function(){$(".cart-item-quantity-minus").on("click",(function(t){t.preventDefault();var e=$(this).attr("data-variant-id"),i=$(`#cart-item-quantity-variant-id-${e}`).val(),a=parseInt(i)-1;a>0&&($(`#cart-item-quantity-variant-id-${e}`).val(a),document.querySelector(`#cart-item-quantity-variant-id-${e}`).dispatchEvent(new Event("change",{bubbles:!0})))})),$(".cart-item-quantity-plus").on("click",(function(t){t.preventDefault();var e=$(this).attr("data-variant-id"),i=$(`#cart-item-quantity-variant-id-${e}`).val(),a=parseInt(i)+1;$(`#cart-item-quantity-variant-id-${e}`).val(a),document.querySelector(`#cart-item-quantity-variant-id-${e}`).dispatchEvent(new Event("change",{bubbles:!0}))}))})),window.location.pathname.includes("/products/")&&document.addEventListener("DOMContentLoaded",(function(){var t=document.querySelectorAll(".product-tabs__label");t.forEach((function(e){e.addEventListener("click",(function(){var e=document.querySelector(".product-tabs__label.active-tab");e!==this&&(e&&(e.classList.remove("active-tab"),e.nextElementSibling.style.display="none"),this.classList.add("active-tab"),this.nextElementSibling.style.display="block");window.innerWidth<=719&&scrollToDescriptionOnTabClick&&t[0].scrollIntoView({behavior:"smooth",block:"start"})}))}))}));

/* Checkout buttons: navigate to regular checkout (skip Shop Pay auto-redirect).
   On the cart page, sync quantities + note to the cart first so last-second
   edits are never lost, then navigate. Delegated so it also works inside the
   dynamically rendered mini cart. */
document.addEventListener("click", function (event) {
  var button = event.target.closest("[data-cart-checkout-button]");
  if (!button || button.classList.contains("disabled")) return;
  event.preventDefault();
  var checkoutUrl = "/checkout?skip_shop_pay=true";
  var form = button.closest("form[data-cart-form]");
  if (!form || !window.fetch) {
    window.location.href = checkoutUrl;
    return;
  }
  button.classList.add("disabled");
  fetch("/cart/update.js", { method: "POST", body: new FormData(form) })
    .catch(function () {})
    .then(function () {
      window.location.href = checkoutUrl;
    });
});

/* Order minimum note: hide once the cart total reaches the configured
   minimum. The mini cart re-renders through Liquid on every refresh so it
   handles itself; this covers AJAX quantity changes on the cart page by
   watching the total and re-checking against /cart.js. */
(function () {
  function updateOrderMinimumNotes() {
    var notes = document.querySelectorAll("[data-order-minimum-note]");
    if (!notes.length || !window.fetch) return;
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-order-minimum-note]").forEach(function (note) {
          var minimum = parseInt(note.getAttribute("data-order-minimum-cents"), 10) || 0;
          note.hidden = cart.total_price >= minimum;
        });
      })
      .catch(function () {});
  }
  document.addEventListener("DOMContentLoaded", function () {
    var cartTotal = document.querySelector("[data-cart-total]");
    if (cartTotal && window.MutationObserver) {
      new MutationObserver(updateOrderMinimumNotes).observe(cartTotal, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  });
})();

/* Save for later: adds a "Save for later" link to cart rows and a saved
   items section below the cart. Saved lines are added to the customer's
   Swish wishlist (window.WishlistKing API) so they sync across devices,
   and tracked in localStorage so only items saved FROM THE CART appear
   in the section (not the whole wishlist). If the Swish script hasn't
   loaded or errors, saving still works locally and re-syncs on the next
   cart visit. Removal from the cart reuses the theme's own remove link
   so atlantic.js handles the AJAX update and re-render. */
(function () {
  var STORAGE_KEY = "tejas_saved_for_later";
  var container = null;
  var itemsEl = null;
  var wishlistItemIds = {}; /* variantId -> Swish wishlist item id */
  var productCache = {};

  function loadMarkers() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function saveMarkers(markers) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(markers));
    } catch (e) {}
  }

  function withTimeout(promise, ms) {
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () { reject(new Error("timeout")); }, ms);
      promise.then(
        function (value) { clearTimeout(timer); resolve(value); },
        function (error) { clearTimeout(timer); reject(error); }
      );
    });
  }

  /* The Swish script loads async via jsdelivr; poll briefly for its API. */
  function getCreds(maxWaitMs) {
    return new Promise(function (resolve, reject) {
      var waited = 0;
      (function poll() {
        var creds = window.WishlistKing && window.WishlistKing.apis && window.WishlistKing.apis.wishlist;
        if (creds) return resolve(creds);
        if (waited >= maxWaitMs) return reject(new Error("wishlist api unavailable"));
        waited += 250;
        setTimeout(poll, 250);
      })();
    });
  }

  function wkRequest(creds, endpoint, method, payload) {
    var headers = {};
    for (var key in creds.headers) headers[key] = creds.headers[key];
    headers["x-appmate-sid"] = localStorage.getItem("wk_session_id") || "";
    var options = { method: method || "GET", headers: headers, keepalive: true };
    if (payload && (options.method === "POST" || options.method === "DELETE")) {
      options.body = JSON.stringify(payload);
    }
    return fetch(creds.host + endpoint, options)
      .then(function (response) {
        if (!response.ok) throw new Error("wishlist http " + response.status);
        var contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json();
        }
        return null;
      })
      .then(function (data) {
        if (data && data.sessionId) {
          try { localStorage.setItem("wk_session_id", data.sessionId); } catch (e) {}
        }
        return data;
      });
  }

  function fetchWishlistItems(creds) {
    return wkRequest(creds, "/wishlists/mine").then(function (result) {
      return (result && result.wishlist && result.wishlist.items) || [];
    });
  }

  function addToWishlist(creds, marker) {
    return wkRequest(creds, "/wishlists/mine/items", "POST", {
      variantId: marker.variantId,
      productId: marker.productId
    });
  }

  function markSynced(variantId) {
    var markers = loadMarkers();
    markers.forEach(function (marker) {
      if (marker.variantId === variantId) marker.synced = true;
    });
    saveMarkers(markers);
  }

  function removeMarker(variantId) {
    var markers = loadMarkers().filter(function (marker) {
      return marker.variantId !== variantId;
    });
    saveMarkers(markers);
    return markers;
  }

  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch("/products/" + handle + ".js", {
        headers: { Accept: "application/json" }
      }).then(function (response) {
        return response.ok ? response.json() : null;
      }).catch(function () {
        return null;
      });
    }
    return productCache[handle];
  }

  function formatMoney(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  function sizedImage(url, width) {
    if (!url) return null;
    return url + (url.indexOf("?") === -1 ? "?" : "&") + "width=" + width;
  }

  function buildCard(marker, product) {
    if (!product || !product.variants || !product.variants.length) return null;
    var variant = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === marker.variantId) {
        variant = product.variants[i];
        break;
      }
    }
    if (!variant) return null;

    var url = "/products/" + product.handle + "?variant=" + variant.id;
    var imageUrl =
      (variant.featured_image && variant.featured_image.src) ||
      (product.images && product.images[0]) ||
      product.featured_image;

    var item = document.createElement("div");
    item.className = "sfl-item";
    item.setAttribute("data-sfl-item", marker.variantId);

    var imageLink = document.createElement("a");
    imageLink.className = "sfl-image";
    imageLink.href = url;
    if (imageUrl) {
      var img = document.createElement("img");
      img.src = sizedImage(imageUrl, 180);
      img.alt = product.title;
      img.loading = "lazy";
      img.width = 90;
      img.height = 90;
      imageLink.appendChild(img);
    }
    item.appendChild(imageLink);

    var details = document.createElement("div");
    details.className = "sfl-details";

    var titleLink = document.createElement("a");
    titleLink.className = "sfl-title";
    titleLink.href = url;
    titleLink.textContent = product.title;
    details.appendChild(titleLink);

    if (variant.title && variant.title !== "Default Title") {
      var variantEl = document.createElement("span");
      variantEl.className = "sfl-variant";
      variantEl.textContent = variant.title;
      details.appendChild(variantEl);
    }

    if (marker.quantity > 1) {
      var qtyEl = document.createElement("span");
      qtyEl.className = "sfl-qty";
      qtyEl.textContent = "Qty: " + marker.quantity;
      details.appendChild(qtyEl);
    }

    var priceEl = document.createElement("span");
    priceEl.className = "sfl-price";
    var money = document.createElement("span");
    money.className = "money";
    money.textContent = formatMoney(variant.price);
    priceEl.appendChild(money);
    details.appendChild(priceEl);

    var actions = document.createElement("div");
    actions.className = "sfl-actions";

    var moveButton = document.createElement("button");
    moveButton.type = "button";
    moveButton.className = "action-button sfl-move";
    moveButton.setAttribute("data-sfl-move", marker.variantId);
    moveButton.textContent = variant.available === false ? "Sold out" : "Move to cart";
    if (variant.available === false) moveButton.disabled = true;
    actions.appendChild(moveButton);

    var removeLink = document.createElement("a");
    removeLink.className = "sfl-remove";
    removeLink.href = "#";
    removeLink.setAttribute("role", "button");
    removeLink.setAttribute("data-sfl-remove", marker.variantId);
    removeLink.textContent = "Remove";
    actions.appendChild(removeLink);

    details.appendChild(actions);
    item.appendChild(details);
    return item;
  }

  function render(markers) {
    if (!container) return;
    if (!markers.length) {
      container.hidden = true;
      itemsEl.innerHTML = "";
      return;
    }
    var jobs = markers.map(function (marker) {
      return getProduct(marker.handle).then(function (product) {
        return { marker: marker, product: product };
      });
    });
    Promise.all(jobs).then(function (results) {
      var dropped = false;
      itemsEl.innerHTML = "";
      results.forEach(function (result) {
        var card = result.product && buildCard(result.marker, result.product);
        if (card) {
          itemsEl.appendChild(card);
        } else {
          /* Product or variant no longer exists; clean up quietly. */
          removeMarker(result.marker.variantId);
          dropped = true;
        }
      });
      var remaining = dropped ? loadMarkers() : markers;
      container.hidden = remaining.length === 0 || itemsEl.children.length === 0;
    });
  }

  /* Reconcile local markers with the Swish wishlist: drop markers whose
     items were removed from the wishlist elsewhere, retry adds that
     failed at save time, and learn wishlist item ids for later removal. */
  function verify() {
    withTimeout(getCreds(6000), 7000)
      .then(function (creds) {
        return fetchWishlistItems(creds).then(function (items) {
          var byVariant = {};
          items.forEach(function (item) {
            if (item.variantId) byVariant[Number(item.variantId)] = item;
          });
          var changed = false;
          var markers = loadMarkers().filter(function (marker) {
            var wishlistItem = byVariant[marker.variantId];
            if (wishlistItem) {
              wishlistItemIds[marker.variantId] = wishlistItem.id;
              if (!marker.synced) { marker.synced = true; changed = true; }
              return true;
            }
            if (marker.synced) {
              /* Saved moments ago? The app's backend may not reflect the
                 add yet; don't trust its absence until things settle. */
              if (Date.now() - (marker.savedAt || 0) < 5 * 60 * 1000) return true;
              /* Was on the wishlist, removed elsewhere: respect that. */
              changed = true;
              return false;
            }
            /* Never made it to the wishlist; retry in the background. */
            addToWishlist(creds, marker).then(function () {
              markSynced(marker.variantId);
            }).catch(function () {});
            return true;
          });
          if (changed) {
            saveMarkers(markers);
            render(markers);
          }
        });
      })
      .catch(function () { /* Swish unavailable; local view stands. */ });
  }

  function addToCart(variantId, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error("add failed");
      return response.json();
    });
  }

  function showError(itemEl, message) {
    if (!itemEl) return;
    var existing = itemEl.querySelector(".sfl-error");
    if (existing) existing.remove();
    var error = document.createElement("span");
    error.className = "sfl-error";
    error.textContent = message;
    itemEl.querySelector(".sfl-details").appendChild(error);
  }

  /* Save for later click (cart rows). */
  document.addEventListener("click", function (event) {
    var link = event.target.closest("[data-save-for-later]");
    if (!link) return;
    event.preventDefault();
    if (link.classList.contains("is-saving")) return;
    link.classList.add("is-saving");
    link.textContent = "Saving...";

    var row = link.closest("[data-cart-item]");
    var qtyInput = row && row.querySelector("[data-cart-item-quantity]");
    var marker = {
      productId: Number(link.getAttribute("data-product-id")),
      variantId: Number(link.getAttribute("data-variant-id")),
      handle: link.getAttribute("data-product-handle"),
      quantity: (qtyInput && parseInt(qtyInput.value, 10)) || 1,
      savedAt: Date.now(),
      synced: false
    };

    var markers = loadMarkers().filter(function (existing) {
      return existing.variantId !== marker.variantId;
    });
    markers.unshift(marker);
    saveMarkers(markers);

    var finish = function () {
      var removeLink = row && row.querySelector('[data-cart-action="remove"]');
      if (removeLink) removeLink.click();
      render(loadMarkers());
    };

    /* Try to sync to the wishlist first (bounded wait) so it survives the
       page reload the theme performs when the cart empties. keepalive on
       the request covers the navigation case too. */
    withTimeout(
      getCreds(2500).then(function (creds) {
        return addToWishlist(creds, marker);
      }),
      3500
    )
      .then(function () { markSynced(marker.variantId); })
      .catch(function () { /* verify() retries on next cart visit */ })
      .then(finish, finish);
  });

  /* Move to cart / remove clicks (saved section). */
  document.addEventListener("click", function (event) {
    var moveButton = event.target.closest("[data-sfl-move]");
    var removeLink = event.target.closest("[data-sfl-remove]");
    if (!moveButton && !removeLink) return;
    event.preventDefault();

    var variantId = Number(
      (moveButton || removeLink).getAttribute(moveButton ? "data-sfl-move" : "data-sfl-remove")
    );
    var itemEl = (moveButton || removeLink).closest("[data-sfl-item]");

    var deleteFromWishlist = function () {
      var wishlistItemId = wishlistItemIds[variantId];
      if (!wishlistItemId) return Promise.resolve();
      return withTimeout(
        getCreds(1500).then(function (creds) {
          return wkRequest(creds, "/wishlists/mine/items", "DELETE", {
            wishlistItemId: wishlistItemId
          });
        }),
        2500
      ).catch(function () {});
    };

    if (removeLink) {
      var remaining = removeMarker(variantId);
      deleteFromWishlist();
      if (itemEl) itemEl.remove();
      if (container) container.hidden = remaining.length === 0 || itemsEl.children.length === 0;
      return;
    }

    if (moveButton.disabled) return;
    var markers = loadMarkers();
    var marker = null;
    markers.forEach(function (candidate) {
      if (candidate.variantId === variantId) marker = candidate;
    });
    var quantity = (marker && marker.quantity) || 1;

    moveButton.disabled = true;
    moveButton.textContent = "Moving...";

    addToCart(variantId, quantity)
      .catch(function (error) {
        /* Saved quantity may exceed current stock; retry with one. */
        if (quantity > 1) return addToCart(variantId, 1);
        throw error;
      })
      .then(function () {
        removeMarker(variantId);
        return deleteFromWishlist().then(function () {
          window.location.reload();
        });
      })
      .catch(function () {
        moveButton.disabled = false;
        moveButton.textContent = "Move to cart";
        showError(itemEl, "Couldn't add this item, it may be unavailable");
      });
  });

  function init() {
    container = document.querySelector("[data-saved-for-later]");
    if (!container) return;
    itemsEl = container.querySelector("[data-saved-for-later-items]");
    var markers = loadMarkers();
    if (!markers.length) return;
    render(markers);
    verify();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
